export default __webpack_public_path__ + "static/media/facebook.a9b02075.svg";